import { v4 as uuidv4 } from "uuid";
import queryString from "query-string";

import {
  getRecurringDonationPayloadDigio,
  getRecurringPayloadAuthorizeDotNet,
} from "./preparePayload";

const getMandatoryEnv = require("../utils/getMandatoryEnv");

const customError = "Something went wrong, Please try again later!";
const { donationServiceConfig } = getMandatoryEnv(["donationServiceConfig"]);

const continueRecurringPaymentProcess = ({
  digioPaymentUrl,
  digioResultUri,
  digioJSON,
  monthlyRecurringDonationState,
  email_id,
  data,
}) => {
  const { donation_type } = monthlyRecurringDonationState;
  const { mandate_id, id } = digioJSON.otherDetail;
  const isOnline = donation_type === "ONLINE";
  const isStatus = digioJSON.status === 1;
  const { citizenship } = data.customerDetail;
  const isIndianCitizen = citizenship === "India";

  // ONLINE - with mandate-id
  if (id && mandate_id && isOnline) {
    const paymentGatewayURL = [
      `${digioPaymentUrl}${mandate_id}`,
      uuidv4(),
      `${email_id}?redirect_url=${digioResultUri}`,
    ].join("/");
    window.location.href = paymentGatewayURL;
    return;
  }
  // ONLINE - without mandate-id
  if (id && !mandate_id && isOnline && !isIndianCitizen && isStatus) {
    return;
    // overseas donations message (already handled)
  }
  // OFFLINE  - status-1
  if (!isOnline && isStatus) {
    const payload = {
      type: "offline",
      status: "success",
    };
    window.location.href = [
      window.location.href,
      `?${queryString.stringify(payload)}`,
    ].join("");
  }
  // OFFLINE - status-0
  if (!isOnline && !isStatus) {
    // form-fields error (this may not be required as it is already handled by profile)
  }
};

function makeDigioApiCall(
  data,
  setLoader,
  onFailure,
  monthlyRecurringDonationState
) {
  const { digioRecurringUri, digioPaymentUrl, digioResultUri } =
    donationServiceConfig;
  setLoader(true);
  fetch(digioRecurringUri, {
    method: "POST",
    headers: new Headers({ "Content-type": "application/json" }),
    body: JSON.stringify(data),
  })
    .then((res) => res.json())
    .then((digioJSON) => {
      setLoader(false);
      if (digioJSON) {
        if (
          data.customerDetail.donationType === "ONLINE" &&
          digioJSON.otherDetail
        ) {
          continueRecurringPaymentProcess({
            digioPaymentUrl,
            digioResultUri,
            digioJSON,
            monthlyRecurringDonationState,
            email_id: data.customerDetail.emailAddress,
            data,
          });
        } else if (digioJSON.redirectUrl) {
          window.location.href = digioJSON.redirectUrl;
        }
      } else {
        onFailure(
          `customErrorMessage: Server returned Invalid Response, Please try again later!`
        );
      }
    })
    .catch(() => {
      setLoader(false);
      onFailure(`customErrorMessage: ${customError}`);
    });
}

function donationsRecurringService(
  formData,
  setLoader,
  onFailure,
  monthlyDonationRecurringState = { isMonthlyRecurringDonation: false }
) {
  const { donation_type } = monthlyDonationRecurringState;
  if (
    monthlyDonationRecurringState.isMonthlyRecurringDonation &&
    donation_type === "ONLINE"
  ) {
    if (formData.currency === "USD") {
      const payload = getRecurringPayloadAuthorizeDotNet({
        recurringState: monthlyDonationRecurringState,
        formData,
      });
      const { authorizeDotNetRecurringPreSubscribe } = donationServiceConfig;
      setLoader(true);
      fetch(authorizeDotNetRecurringPreSubscribe, {
        method: "POST",
        headers: new Headers({ "Content-type": "application/json" }),
        body: JSON.stringify(payload),
      })
        .then((response) => {
          if (response.ok) {
            setLoader(false);

            response.json().then((json) => {
              const paymentGateway = new URL(json.paymentGatewayUrl);
              paymentGateway.host = window.location.host;
              window.location.href = paymentGateway;
              return null;
            });
          }
        })
        .catch(() => {
          setLoader(false);
          onFailure(`customErrorMessage: ${customError}`);
        });
    }
    if (formData.currency === "INR") {
      const payload = getRecurringDonationPayloadDigio({
        recurringState: monthlyDonationRecurringState,
        formData,
      });
      makeDigioApiCall(
        payload,
        setLoader,
        onFailure,
        monthlyDonationRecurringState
      );
    }
  } else if (
    (monthlyDonationRecurringState.showOfflineRecurringSection &&
      donation_type === "OFFLINE") ||
    (monthlyDonationRecurringState.isMonthlyRecurringDonation &&
      donation_type === "OFFLINE")
  ) {
    // Recurring offline donation goes here
    if (formData.currency === "INR") {
      const payload = getRecurringDonationPayloadDigio({
        recurringState: monthlyDonationRecurringState,
        formData,
      });
      makeDigioApiCall(payload, setLoader, onFailure);
    }
  }
}

export default donationsRecurringService;
